import { ROUTES } from '@constants/index'
import { useClaimRecord } from '@hooks/useClaimRecord'
import { useInsuranceUsage } from '@pages/InsuranceMember/hooks/useInsuranceUsage'
import { drawerEventEmitter } from '@utils/drawerEventEmitter'
import { getInsuranceToggleState } from '@utils/insuranceToggleUtil'

type UseInsuranceBenefitsUsageReturn = {
  addInsuranceBenefits: () => Promise<void>
  removeInsuranceBenefits: () => Promise<void>
}

/**
 * Handle add / remove benefits from commmerce F/E
 */
export const useInsuranceBenefitsUsage = (): UseInsuranceBenefitsUsageReturn => {
  const { claimRecord, claimRecordDeleted } = useClaimRecord()
  const { enableInsuranceUsage, disableInsuranceUsage } = useInsuranceUsage()

  // show drawer or enable insurance usage
  const addInsuranceBenefits = (): Promise<void> => {
    const { toggleOn, allowOn } = getInsuranceToggleState({ claimRecord, claimRecordDeleted })

    if (allowOn && !toggleOn) {
      return enableInsuranceUsage()
    } else {
      drawerEventEmitter.openDrawer({ target: ROUTES.INSURANCE_MEMBER })
      return Promise.resolve()
    }
  }

  // disable insurance usage
  const removeInsuranceBenefits = (): Promise<void> => {
    const { toggleOn } = getInsuranceToggleState({ claimRecord, claimRecordDeleted })
    if (!toggleOn) return Promise.resolve()

    return disableInsuranceUsage()
  }

  return {
    addInsuranceBenefits,
    removeInsuranceBenefits,
  }
}
